<ng-container *ngIf="bookmarkId">
  <button
    app-button
    [buttonTheme]="theme" 
    [matMenuTriggerFor]="mainMenu"
    (menuOpened)="handleMenuOpened()">
    <app-icon icon="ellipsis-v"></app-icon>
  </button>

  <mat-menu #mainMenu="matMenu">
    <ng-container *ngIf="!bookmark">
      <app-spinner></app-spinner>
    </ng-container>
    
    <ng-container *ngIf="bookmark">
      <!-- View -->
      <button 
        *ngIf="hasActions(bookmarkActionsEnum.View)"
        mat-menu-item [routerLink]="['/view']" 
        [queryParams]="{'id': bookmarkId}">
        View
      </button>

      <!-- Edit -->
      <button 
        *ngIf="hasActions(bookmarkActionsEnum.Edit)"
        mat-menu-item 
        [routerLink]="['/edit']" 
        [queryParams]="{'id': bookmarkId}">
        Edit in Studio
      </button>

      <mat-divider *ngIf="hasActions(bookmarkActionsEnum.View, bookmarkActionsEnum.Edit)"></mat-divider>


      <!-- Copy Link -->
      <button 
        *ngIf="hasActions(bookmarkActionsEnum.CopyLink)"
        mat-menu-item
        (click)="handleCopyLinkClick()">
        Copy URL
      </button>
      
      <!-- Embed -->
      <button 
        *ngIf="hasActions(bookmarkActionsEnum.Embed)"
        mat-menu-item
        (click)="handleEmbedModel()">
        Publish...
      </button>

      <mat-divider *ngIf="hasActions(bookmarkActionsEnum.Manage, bookmarkActionsEnum.Delete)"></mat-divider>

      <button 
        *ngIf="hasActions(bookmarkActionsEnum.Manage)"
        mat-menu-item 
        (click)="handleManageClick()">
        Manage...
      </button>

      <!-- Delete -->
      <button 
        *ngIf="hasActions(bookmarkActionsEnum.Delete)"
        mat-menu-item
        (click)="handleDeleteClick()">
        Delete...
      </button>

      <!-- external only -->
      <ng-container *appFlagExternal>

        <mat-divider *ngIf="hasActions(bookmarkActionsEnum.CopyBookmark)"></mat-divider>

        <!-- Copy to My Models -->
        <button
          *ngIf="hasActions(bookmarkActionsEnum.CopyBookmark)"
          (click)="handleCopyBookmarkClick()"
          mat-menu-item>
          Add to My Models
        </button>

        <!-- Copy to Team Models -->
        <button
          *ngIf="hasActions(bookmarkActionsEnum.CopyTeamBookmark)"
          (click)="handleAddTeamModelClick()"
          mat-menu-item>
          Add to Team Models
        </button>

      </ng-container>
    </ng-container>
  </mat-menu>
</ng-container>